import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/level-skills', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/level-skills', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
    return httpClient
        .put(`/api/level-skills/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
    return httpClient
        .delete(`/api/level-skills/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const formModel = (options = {}) => {
    return httpClient
        .get('/api/level-skills/form-view-models', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default { get, store, update, destroy, formModel }